if (!customElements.get("bought-together")) {
    class BoughtTogether extends HTMLElement {
        connectedCallback() {
            if (this.abortController) return;

            this.abortController = new AbortController();
            this.mainPrice = this.getMainPrice();
            this.mainForm = this.getMainForm();
            this.mainInput = this.querySelector('input[name="items[0][id]"]');
            this.addEventListener("change", () => this.updateSummary(), { signal: this.abortController.signal });
            this.mainForm?.addEventListener("change", () => this.syncMainVariant(), { signal: this.abortController.signal });

            if (this.mainPrice) {
                this.mainPriceMutation = new MutationObserver(() => {
                    this.syncMainAvailability();
                    this.updateSummary();
                });
                this.mainPriceMutation.observe(this.mainPrice.closest('[data-updatable="true"]') || this.mainPrice, {
                    childList: true,
                    subtree: true,
                });
            }

            this.syncMainAvailability();
            this.updateSummary();
        }

        disconnectedCallback() {
            this.abortController?.abort();
            this.abortController = null;
            this.mainPriceMutation?.disconnect();
        }

        syncMainVariant() {
            const variantId = this.mainForm?.querySelector('input[name="id"]')?.value;
            if (variantId && this.mainInput) this.mainInput.value = variantId;

            const price = this.getMainPrice();
            if (price?.dataset.amount && this.mainInput) {
                this.mainInput.dataset.price = String(Math.round(this.parsePrice(price.dataset.amount) * 100));
                this.mainInput.dataset.comparePrice = this.mainInput.dataset.price;
            }
            this.syncMainAvailability();
            this.updateSummary();
        }

        syncMainAvailability() {
            if (!this.mainInput) return;
            const includesMain = this.datasetIncludesMainProduct() === "true";
            this.mainInput.disabled = !includesMain || this.isMainSoldout();
        }

        getSelectedLines() {
            const seen = new Set();
            return Array.from(this.querySelectorAll('[data-bundle-line]')).filter((input) => {
                if (input.disabled || (input.type === "checkbox" && !input.checked) || seen.has(input.value)) return false;
                seen.add(input.value);
                return true;
            });
        }

        updateSummary() {
            const lines = this.getSelectedLines();
            const total = lines.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
            const original = lines.reduce((sum, input) => {
                const price = Number(input.dataset.price || 0);
                return sum + Math.max(price, Number(input.dataset.comparePrice || price));
            }, 0);
            const saving = Math.max(0, original - total);

            const count = this.querySelector('[data-bundle-count]');
            if (count) count.textContent = String(lines.length);

            const list = this.querySelector('[data-bundle-selected]');
            if (list) {
                list.replaceChildren(...lines.slice(0, 3).map((input) => {
                    const item = document.createElement("li");
                    item.textContent = input.dataset.title || "Ürün";
                    return item;
                }));
                if (lines.length > 3) {
                    const remaining = document.createElement("li");
                    remaining.textContent = `+${lines.length - 3} ürün daha`;
                    list.append(remaining);
                }
            }

            this.querySelector('[data-bundle-empty]')?.toggleAttribute("hidden", lines.length > 0);
            const submit = this.querySelector('.summary [type="submit"]');
            if (submit) submit.disabled = lines.length === 0;

            const originalPrice = this.querySelector('[data-bundle-original]');
            const savingPrice = this.querySelector('[data-bundle-saving]');
            if (originalPrice) {
                originalPrice.textContent = this.formatMoney(original);
                originalPrice.toggleAttribute("hidden", saving === 0);
            }
            if (savingPrice) {
                savingPrice.textContent = `${this.formatMoney(saving)} tasarruf`;
                savingPrice.toggleAttribute("hidden", saving === 0);
            }

            this.renderTotal(total);
        }

        renderTotal(total) {
            const price = this.querySelector(".summary .price--final");
            if (!price) return;
            price.textContent = this.formatMoney(total);
            price.dataset.amount = String(total);
        }

        formatMoney(cents) {
            return new Intl.NumberFormat(this.getLocalization(), {
                style: "currency",
                currency: this.getCurrencyCode(),
            }).format(cents / 100);
        }

        parsePrice(price) {
            const normalized = String(price || "");
            const decimalSeparator = this.getPriceDecimalSeparator();
            if (decimalSeparator === ",") return Number(normalized.replace(/\./g, "").replace(",", "."));
            return Number(normalized.replace(/,/g, ""));
        }

        getMainPrice() {
            return document.querySelector(".product-section .price--final");
        }

        getMainForm() {
            return document.querySelector(".product-section product-form");
        }

        isMainSoldout() {
            const price = this.getMainPrice();
            return !price || !!price.closest(".price--sold-out");
        }

        datasetIncludesMainProduct() {
            return this.querySelector(".summary")?.dataset.includesMainProductPrice;
        }

        getLocalization() {
            return `${window.Shopify.locale}-${window.Shopify.country}`;
        }

        getCurrencyCode() {
            return window.Shopify.currency.active;
        }

        getSamplePrice() {
            return this.querySelector('template[data-id="price"]')?.dataset.priceSample || "0,00";
        }

        getPriceDecimalSeparator() {
            return this.getSamplePrice().includes(",") ? "," : ".";
        }
    }

    customElements.define("bought-together", BoughtTogether);
}
